export const nameAndEmailInputLength = 72;

export const phoneInputLength = 15;

export const rateInputLength = 3;

export const textareaLength = 800;
